import ULThemeSeparator from "@/components/ULThemeSeparator";
import { applyAuth0Theme } from "@/utils/theme";

import MFALoginOptionsList from "./components/MFALoginOptionsList";
import { useMfaLoginOptionsManager } from "./hooks/useMFALoginOptionsManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function MFALoginOptions() {
    // Extracting attributes from hook made out of MFALoginOptionsInstance class of Auth0 React SDK
    const { mfaLoginOptions, texts, locales } = useMfaLoginOptionsManager();

    // Apply theme from SDK instance when screen loads
    applyAuth0Theme(mfaLoginOptions);
    return (
        // Applying UDS theme overrides using the "theme-universal" class
        <AuthLayout title={texts?.pageTitle || locales.pageTitle}>

            <ULThemeSeparator className="grow-0" />
            <MFALoginOptionsList />

        </AuthLayout>
    );
}

export default MFALoginOptions;
